import { authenticateUser, changePassword, getUserAttributes } from 'util/user-manager';
import { NotificationManager } from 'react-notifications';

export const signIn = (credentials, themeToApply) => {
    return (dispatch) => {
        authenticateUser(credentials.username, credentials.password)
            .then((data) => {
                if (data.idToken.payload['cognito:groups']) {
                    if (data.idToken.payload['cognito:groups'].includes('sym-admin')) {
                        dispatch({ type: "IS_ADMIN?", payload: true });
                    }
                    else {
                        dispatch({ type: "IS_ADMIN?", payload: false });
                    }
                }

                if (themeToApply === 'dark_theme') {
                    dispatch({ type: 'dark_theme' })
                }
                else {
                    dispatch({ type: 'theme_color', color: themeToApply })
                }
                dispatch({ type: "SIGN_IN", payload: credentials, loginData: data.idToken.payload })
                getUserAttributes()
                    .then((data) => {
                        dispatch({ type: "FETCHED_USER_ATTRIBUTES", payload: data });
                    }, (error) => {
                        console.log("Error Attributes", error);
                    });
            }, (error) => {
                NotificationManager.error(error.message)
            })
    };
}


// WEBPACK FOOTER //
// ./actions/CustomAuth.js